module.exports = __webpack_public_path__ + "assets/img/YCSC-2.07972145.jpg";